import {getNovSchema} from '../../utility';
import { getBaseUrl } from 'data/DataStore';

class GetStoryElementsByIsbnUrlBuilder {
	generateUrl(profileData, isbn) {
		const apiEndpoint = `${getNovSchema()}${window.novSelect.baseUrl || getBaseUrl()}/api/storyMixer/StoryElements?`;
        const queryInfo = `profile=${profileData.Profile}&password=${profileData.Password}&isbn=${isbn}`;

		const url = `${apiEndpoint}${queryInfo}`;

		return encodeURI(url);
	}
}

export default GetStoryElementsByIsbnUrlBuilder;



// WEBPACK FOOTER //
// ./src/lib/dataRetrieval/GetStoryElementsByIsbnUrlBuilder.js